import * as React from "react";
import type { SVGProps } from "react";
const SvgContractDocumentPen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.614 20.813a.96.96 0 0 1-.679.281H12V19.16a.96.96 0 0 1 .281-.679l6.501-6.506a1.653 1.653 0 0 1 2.338 0v0a1.65 1.65 0 0 1 0 2.338z"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m16.384 14.38 2.334 2.334M20.373 15.058l.864.864v0a1.17 1.17 0 0 1 0 1.65l-1.576 1.576M7.198 9.57h5.763M7.198 13.41h3.842M9.119 21.094H6.238a2.88 2.88 0 0 1-2.882-2.88V6.687a2.88 2.88 0 0 1 2.882-2.88h11.524a2.88 2.88 0 0 1 2.882 2.88V8.61"
    />
  </svg>
);
export default SvgContractDocumentPen;
